module.exports = __webpack_public_path__ + "static/media/drake.77dfc804.png";